import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { IS_RETAILER } from "../../../../utils/Api";
import { get, patch } from "../../../../utils/request";
import { IHoldItem, IShippingForm, OrderStatusType } from "../types";
import {
  selectEndDate,
  selectHoldItems,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectShippingForm,
  selectStartDate,
  selectStatusFilter,
} from "./selector";
import { actions } from "./slice";
import { t } from "i18next";

export function* doGetListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const orderBy: string = yield select(selectOrderBy);
    const orderDir: string = yield select(selectOrderDir);
    const search: string = yield select(selectSearch);
    const startDate: string = yield select(selectStartDate);
    const endDate: string = yield select(selectEndDate);
    const filter: OrderStatusType = yield select(selectStatusFilter);
    const response: AxiosResponse = yield call(
      get,
      `${
        IS_RETAILER === "true" ? "retailer/order/list" : "order/list"
      }?pageNo=${pageNo}&pageSize=${pageSize}&filter=${filter}${
        search.length > 0 ? "&search=" + search : ""
      }${orderBy.length > 0 ? "&orderBy=" + orderBy : ""}${
        orderDir.length > 0 ? "&orderDirection=" + orderDir : ""
      }${
        startDate ? "&startDate=" + startDate : ""
      }${endDate ? "&endDate=" + endDate : ""}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(
      actions.setTotalRow(
        response.data.data.meta ? response.data.data.meta.total : 0
      )
    );
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));

    CatchBlockFunction(error);
  }
}
export function* doGetByIdRequest(action: { payload: string }) {
  yield delay(500);

  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      get,
      `${IS_RETAILER === "true" ? "retailer/order" : "order"}/${
        action.payload !== undefined && action.payload !== null
          ? action.payload
          : ""
      }`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setDataForm(response.data.data[0]));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}

export function* doUpdateStatusRequest(action: {
  payload: { id: string; action: OrderStatusType; callback: () => void };
}) {
  yield delay(500);
  try {
    const holdItems: Array<IHoldItem> = yield select(selectHoldItems);
    const shippingForm: IShippingForm = yield select(selectShippingForm);
    if (action.payload.action === OrderStatusType.SHIPPED) {
      if (
        !shippingForm.deliveryCompany ||
        !shippingForm.estimatedDeliveryDate ||
        !shippingForm.trackingNo ||
        !shippingForm.trackingUrl
      ) {
        toast.error(t("order.modal.fillShippingDetails"));
        return;
      }
    }

    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `${
        IS_RETAILER === "true"
          ? "retailer/order/update/status/"
          : "order/update/status/"
      }${
        action.payload.id !== undefined && action.payload.id !== null
          ? action.payload.id
          : ""
      }`,

      {
        action: action.payload.action,
        orderPackageItemId: holdItems,
        ...shippingForm,
      }
    );
    yield put(actions.setButtonLoading(false));

    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.clearShippingForm());
    toast.success(response.data.message);
    yield call(action.payload.callback);
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}

export function* OrderRepoSaga() {
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.doGetById, doGetByIdRequest);
  yield takeLatest(actions.doUpdateStatus, doUpdateStatusRequest);

}
